export default "__VITE_ASSET__C36H_e6L__"